import { createStore } from 'vuex'
import groups_list from "./modules/groups_list"
import group_info from "./modules/group_info"
import product from "./modules/product";
import bread_crumbs from "./modules/bread_crumbs";
import search_products from "./modules/search_products";

const store = createStore({
    modules: {
        groups_list,
        group_info,
        product,
        bread_crumbs,
        search_products,
    }
})

export default store